// extracted by mini-css-extract-plugin
export default {"testimonial":"testimonial_testimonial__Iw62V","testimonials":"testimonial_testimonials__KvdVw"};